import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SubscriptionType } from 'src/app/types/subscription';
import { SecondaryButtonComponent } from '../../../../components/secondary-button/secondary-button.component';

@Component({
  selector: 'app-ordering-confirmation',
  templateUrl: './ordering-confirmation.component.html',
  styleUrls: ['./ordering-confirmation.component.scss'],
  imports: [SecondaryButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class OrderingConfirmationComponent {
  @Input() subscriptionType: SubscriptionType = 'SCHOOL_S';
  @Input() emailAddress = '';
  @Output() closeDialog = new EventEmitter<void>();

  onClose() {
    this.closeDialog.emit();
  }
}
